import * as supplierApi from '../api/supplier';
import { KeyedAsyncCache } from './asyncCache';

export interface FrontendSupplier {
  id: string;
  name: string;
  type: supplierApi.BackendSupplierType;
}

function toFrontendSupplier(s: supplierApi.BackendSupplier): FrontendSupplier {
  return { id: s._id, name: s.name, type: s.type };
}

/** Active INPUT_SUPPLIER partners for a given HTX — sourced from the admin-managed
 * Supplier list, used to back a real picker instead of a free-text name. */
const inputSuppliersByHtx = new KeyedAsyncCache<FrontendSupplier[]>(
  async (htxId) => (await supplierApi.listSuppliersByHtx(htxId, 'INPUT_SUPPLIER', 'ACTIVE')).map(toFrontendSupplier),
  [],
  'suppliers:inputByHtx',
);

export function getInputSuppliersByHtx(htxId?: string): FrontendSupplier[] {
  if (!htxId) return [];
  return inputSuppliersByHtx.get(htxId);
}
